// extracted by mini-css-extract-plugin
export default {"supplier":"supplier_supplier__OA1PW","item":"supplier_item__aZyRB","label":"supplier_label__HxjGg","val":"supplier_val__o7wnp"};